// Default

export const yesNoOptions = [
  { value: 'yes', label: 'Yes' },
  { value: 'no', label: 'No' },
]

export const acceptedRejectedOptions = [
  {
    value: 'accepted',
    label: 'Accepted by court.',
  },
  {
    value: 'furtherInvestigation',
    label: 'Further investigation ordered by court.',
  },
  {
    value: 'stillToBeSubmitted',
    label: 'Still to be submitted in court.',
  },
  {
    value: 'pendingInCourt',
    label: 'Pending in court.',
  },
]

export const decidedPendingOptions = [
  { value: 'decided', label: 'Decided' },
  { value: 'pending', label: 'Pending' },
]
//  CRIMINAL CASE

export const statusOptions = [
  { value: 'investigation', label: 'Under Investigation' },
  { value: 'untraced', label: 'Untraced' },
  { value: 'cancellation', label: 'Cancellation' },
  { value: 'challan', label: 'Challan Submission' },
]
export const untracedOptions = [
  {
    value: 'accepted',
    label: 'Accepted by court.'
  },
  {
    value: 'furtherInvestigation',
    label: 'Further investigation ordered by court.',
  },
  {
    value: 'stillToBeSubmitted',
    label: 'Still to be submitted in court.',
  }, {
    value: 'pendingInCourt',
    label: 'Pending in court.',
  },
]
export const trialStatusOptions = [
  { value: 'prosecutionEvidence', label: 'Prosecution Evidence' },
  { value: 'defenceEvidence', label: 'Defence Evidence' },
  { value: 'argument', label: 'Argument' },
  { value: 'trialCompleted', label: 'Trial Completed' },
]

export const judgmentOutcomeOptions = [
  { value: 'convicted', label: 'Convicted' },
  { value: 'acquitted', label: 'Acquitted' },
]

export const sentenceTypeOptions = [
  { value: 'imprisonment', label: 'Imprisonment' },
  { value: 'fine', label: 'Fine' },
  {
    value: 'bothImprisonmentAndFine',
    label: 'Both (Imprisonment and Fine)',
  },
  {
    value: 'punishmentUndergone',
    label: 'Punishment Undergone',
  },
]

// Departmental Enquiry

export const defaultPunishment = {
  PermanentEffect: 'Stoppage of increment with Permanent Effect',
  TemporaryEffect: 'Stoppage of increment with Temporary Effect',
}

export const appealOutcomeOptions = [
  { value: 'accepted', label: 'Accepted and Punishment set aside' },
  { value: 'rejected', label: 'Rejected' },
  {
    value: 'partially',
    label: 'Partially accepted and punishment reduced',
  },
  { value: 'notFiled', label: 'Appeal not yet filed' },
  { value: 'punishmentEnhanced', label: 'Punishment Enhanced' },
]

export const appealOutcomeRevisionOptions = [
  { value: 'accepted', label: 'Accepted and Punishment set aside' },
  { value: 'rejected', label: 'Rejected' },
  {
    value: 'partially',
    label: 'Partially accepted and punishment reduced',
  },
  { value: 'notRevisionFiled', label: 'Revision petition not yet filed' },
  { value: 'punishmentEnhanced', label: 'Punishment Enhanced' },
]


